import { defineAction } from '~/prix'
import { z } from 'zod'
import operatorUpdateAction from './operatorUpdate.action.json' with { type: 'json' }
import { operatorUpdateInputObject } from '../operatorObject'

const operatorUpdateDefinition = defineAction({
  ...operatorUpdateAction,

  input: operatorUpdateInputObject,
  output: z.object({}),
})

export default operatorUpdateDefinition
